import axios from 'axios';
import { FileVisualizationDto } from '@/components/SignVisualization/dto/file-visualization.dto';
import { SignVisualizationDto } from '@/components/SignVisualization/dto/sign-visualization.dto';
import {
  DocumentOption, IAvailableVisualizationSetting, mapAvailableVisualizationSettings
} from '@/components/SignVisualizationSettings/visualization-settings.models';
import { SignPageOption, SignPositionOnPage } from '@/models/enums';
import { actions as _act } from '@/models/store.actions';
import store from '@/store/store';
import { FileSignVisualizationDto } from '@/components/SignVisualization/dto/file-sign-visualization.dto';

export const docSignVisualizationService = {
  getDocumentSignPositionsOption,
  saveDocumentSignPositionsOption,
  getVisualizations,
  getSignVisualization,
  saveVisualizations,
  cancelVisualizations,
  getFutureSignVisualizations,
  updateDocumentVisualization,
  getVisualizationSettings,
  getDocumentFiles
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'document-signature-visualization'
};

function extract(r) {
  return r.data;
}

function getDocumentSignPositionsOption(documentVersionCode: string): Promise<DocumentOption> {
  return axios
    .get(`${model.baseUrl}${model.controller}/${documentVersionCode}/option`)
    .then(r => {
      return r.data
        ? new DocumentOption(
          SignPageOption[r.data.documentSignPositionTypeId as string],
          SignPositionOnPage[r.data.documentSignPositionOnPageId as string])
        : new DocumentOption();
    });
}

function saveDocumentSignPositionsOption(documentVersionCode: string, option: DocumentOption): Promise<boolean> {
  return axios
    .post(`${model.baseUrl}${model.controller}/${documentVersionCode}/option`, option)
    .then(extract);
}

async function getVisualizations(documentVersionCode: string,
  documentVersionsFileCodes: Array<string> = []): Promise<Array<FileVisualizationDto>> {
  return axios
    .get(`${model.baseUrl}${model.controller}/${documentVersionCode}/visualizations?documentVersionsFileCodes=${documentVersionsFileCodes}`)
    .then(extract);
}

async function getSignVisualization(documentVersionCode: string, signVisualization: SignVisualizationDto): Promise<SignVisualizationDto> {
  return axios
    .post(`${model.baseUrl}${model.controller}/${documentVersionCode}/sign-visualization`, signVisualization)
    .then(extract);
}

function saveVisualizations(documentVersionCode: string, visualizations: Array<any>): Promise<boolean> {
  return axios
    .post(
      `${model.baseUrl}${model.controller}/${documentVersionCode}/visualizations`,
      visualizations
    )
    .then(extract);
}

function cancelVisualizations(documentVersionCode: string, documentVersionsFileCodes: Array<string> | null = null): Promise<boolean> {
  return axios
    .delete(
      `${model.baseUrl}${model.controller}/${documentVersionCode}/visualizations`,
      { data: documentVersionsFileCodes }
    )
    .then(extract);
}

function getFutureSignVisualizations(documentVersionCode: string, documentVersionsFileCode: string, fileSignatures: Array<FileSignVisualizationDto>,
  signatureNumber: number): Promise<Array<FileSignVisualizationDto>> {
  return axios
    .post(
      `${model.baseUrl}${model.controller}/${documentVersionCode}/visualizations/preview`,
      { documentVersionsFileCode, fileSignatures, signatureNumber }
    )
    .then(extract);
}

function updateDocumentVisualization(documentVersionCode: string, documentVersionsFileCodes: Array<string>): Promise<boolean> {
  return axios
    .put(`${model.baseUrl}${model.controller}/${documentVersionCode}/update`, documentVersionsFileCodes)
    .then(extract);
}

async function getVisualizationSettings(documentVersionCode: string): Promise<Array<IAvailableVisualizationSetting>> {
  return axios
    .get(`${model.baseUrl}${model.controller}/${documentVersionCode}/settings`)
    .then(response => mapAvailableVisualizationSettings(response.data));
}

function getDocumentFiles(documentVersionCode: string): Promise<Array<string>> {
  return axios.get(`${model.baseUrl}${model.controller}/${documentVersionCode}/files`).then(extract);
}
